import React from "react";
import Header from "../components/header/en/Header";
import Footer from "../components/footer/en/Footer";
import Contents from "../components/pages/chat/en/Contents";

const Chat = () => {
  return (
    <>
      <Header />
      <Contents />
      <Footer />
    </>
  );
};

export default Chat;
